import Base from 'pages/Base/Base';
import { theme } from '../../components/layouts/theme';
import { ThemeProvider } from '@mui/material/styles';
import LDAPValidatorSearch from '../IMSLDAPValidator/components/Search';

const IMSLDAPValidator = () => {
	return (
		<ThemeProvider theme={theme}>
			<Base
				loading={false}
				title={'IMS LDAP Validator'}
			>
				<div>
					<LDAPValidatorSearch>
					</LDAPValidatorSearch>
				</div>
			</Base>
		</ThemeProvider>
	);
};

export default IMSLDAPValidator;